import type {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from "react";
import type { To } from "react-router-dom";

import type { IIconName } from "@components/icon";

export enum IButtonSizeEnum {
  Medium = "medium",
  Small = "small",
  "X_Small" = "x-small",
  "2X_Small" = "2x-small",
}
export enum IButtonVariantsEnum {
  Primary = "primary",
  Neutral = "neutral",
  Error = "error",
  Success = "success",
  Basic = "basic",
}
export enum IButtonModeEnum {
  Button = "button",
  Submit = "submit",
}
export enum IButtonStyleEnum {
  Filled = "filled",
  Stroke = "stroke",
  Lighter = "lighter",
  Ghost = "ghost",
  Fancy = "fancy",
}
export enum IButtonLoaderTypeEnum {
  DotPulse = "dotPulse",
  Spinner = "spinner",
}
export interface IButtonProps
  extends PropsWithChildren,
    DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  size?: IButtonSizeEnum;
  variant?: IButtonVariantsEnum;
  linkTo?: To;
  label?: string;
  startIcon?: IIconName;
  endIcon?: IIconName;
  hasUnderline?: boolean;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  mode?: IButtonModeEnum;
  styleType?: IButtonStyleEnum;
  loaderType?: IButtonLoaderTypeEnum;
  defaultCursor?: boolean;
}
